import { render, staticRenderFns } from "./question-info.vue?vue&type=template&id=290dfe90&scoped=true&"
import script from "./question-info.vue?vue&type=script&lang=js&"
export * from "./question-info.vue?vue&type=script&lang=js&"
import style0 from "./question-info.vue?vue&type=style&index=0&id=290dfe90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290dfe90",
  null
  
)

export default component.exports